import { Ban, Pencil, Trash2 } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { RowAction } from '@nucleus-commerce/admin-kit/index-table';
import type { ApiKey } from '@nucleus-commerce/api-client/admin';

export type ApiKeyAction = 'edit' | 'revoke' | 'delete';

/** Edit and revoke (active keys only) and delete; revoke and delete ask for confirmation first. */
export function useApiKeyRowActions(onAction: (action: ApiKeyAction, key: ApiKey) => void) {
  const { t } = useTranslation('apiKeys');
  return useMemo<Array<RowAction<ApiKey>>>(
    () => [
      {
        id: 'edit',
        label: t('actions.edit'),
        icon: <Pencil aria-hidden />,
        hidden: (key) => key.revokedAt !== null,
        onAction: (key) => onAction('edit', key),
      },
      {
        id: 'revoke',
        label: t('actions.revoke'),
        icon: <Ban aria-hidden />,
        hidden: (key) => key.revokedAt !== null,
        onAction: (key) => onAction('revoke', key),
      },
      {
        id: 'delete',
        label: t('actions.delete'),
        icon: <Trash2 aria-hidden />,
        variant: 'destructive',
        onAction: (key) => onAction('delete', key),
      },
    ],
    [onAction, t],
  );
}
